// Global settings
//

// Enviroment
window.enviroment = 'auto'; // 'dev', 'live', 'auto'
window.errorMode = 'silent';

// Template
window.breakpoints = ['xs', 'sm',  'md', 'lg', 'xl', 'xxl'];
window.breakpoint = null;

window.lastScrollPosition = 0;
window.lastScrollDirectionChangePosition = 0;
window.lastScrollDirection = 'down';
window.scrollOffset = 0;
window.headerHeight = 0;
window.headerScrollOffset = 0;
window.windowWidth = 0;
window.windowHeight = 0;

// Language
//

// Mapping
//
window.languages = {
	de: 'deu',
	it: 'ita',
	en: 'eng'
};

// Typo3
window.languagesTypo3 = {
	de: '0',
	it:	'2',
	en: '1'
};

// Detection
//
if (typeof window.lang === 'undefined') {
	window.la = window.document.location.href.split('/');la = la[la.length-2];
	window.lang = languages[la];
} else if (typeof window.la === 'undefined') {
	for (let i in window.languages) 	{
		if (window.languages[i] === window.lang) {
			window.la = i;
		}
	}
}

// Strings
window.strings = {
	show: {
		deu: 'anzeigen',
		eng: 'show',
		ita: 'mostra',
	},
	hide: {
		deu: 'ausblenden',
		eng: 'hide',
		ita: 'nascondere',
	},
	readmore: {
		deu: 'Mehr anzeigen',
		eng: 'show more',
		ita: 'mostra piú',
	},
	readless: {
		deu: 'Weniger anzeigen',
		eng: 'show less',
		ita: 'mostra di meno',
	},
	night: {
		deu: 'Nacht',
		eng: 'night',
		ita: 'notte',
	},
	nights: {
		deu: 'Nächte',
		eng: 'nights',
		ita: 'notti',
	},
	photo: {
		deu: 'Foto',
		eng: 'photo',
		ita: 'foto',
	},
	photos: {
		deu: 'Fotos',
		eng: 'photos',
		ita: 'foto',
	},
}

// Block iFrame
if (top != self && top.location.host != self.location.host) {
	top.location = self.location;
}

// Detect enviroment
if (typeof enviroment !== 'undefined' && enviroment === 'auto') {
	window.enviroment = detectEnviroment();
}

// Consent Tool
window.consentTool = 'auto'; // 'gnConsent', 'auto', 'custom'
window.consentToolActive = false; // true, false, 'auto'
if (typeof gnConsent !== 'undefined' && window.consentTool === 'auto') {
	window.consentTool = 'gnConsent';
	window.consentToolActive = true;
}

// Init
//

window.youtubeApiLoaded = false;
window.vimeoApiLoaded = false;

function init() {
	if (window.enviroment === 'dev') {
		console.info('init');
	}

	// General
	//

	// Breakpoint
	window.breakpoint = detectBreakpoint();

	// Layout
	//

	// Window height
	window.windowHeight = $(window).height();

	// Header height
	if ($('#header').length > 0) {
		window.headerHeight = $('#header').outerHeight();
	}

	// Header scroll offset
	if ($('body').hasClass('noheader')) {
		window.headerScrollOffset = 100;
	} else {
		window.headerScrollOffset = window.headerHeight / 3;
	}



	// Menus
	//

	// Fullscreen menu
	//
	console.log('open');
	// Init
	$('.fullscreenmenu').each(function() {
		try {
			const el = $(this);
			const elId = el.attr('id');
			const toggle = $('.fullscreenmenu-toggle[data-toggle="#' + elId + '"]');

			if (el.hasClass('is-open')) {
				openFullscreenMenu(el, toggle);
			} else {
				closeFullscreenMenu(el, toggle);
			}
		} catch (e) {
			console.warn('Exception in fullscreenmenu init', e);
		}
	});

	// Toggle
	$('.fullscreenmenu-toggle').click(function(e) {
		e.preventDefault();
		try {
			const targetSelector = $(this).attr('data-toggle');
			const el = $(targetSelector);
			const toggle = $('.fullscreenmenu-toggle[data-toggle="' + targetSelector + '"]');


			if (el.hasClass('is-open')) {
				closeFullscreenMenu(el, toggle);
			} else {
				openFullscreenMenu(el, toggle);
			}
		} catch (e) {
			console.warn('Exception in fullscreenmenu-toggle', e);
		}
	});

	// Chiusura del menu con il tasto ESC
	$(document).keyup(function(e) {
		if (e.key === "Escape") {
			closeAllOpenFullscreenMenus();
		}
	});

	// Navigation
	//

	// Auto scroll (if anchor has hash to a existing content element)
	$('a[href*="#c"]:not([href^="javascript:"])').bind('click', function (e) {
		let href = $(this).attr('href');
		href = href.split('#c');
		href = href[1];
		if($('#ce' + href).length > 0) {
			scrollToElement($('#ce' + href));
		} else {
			return true;
		}
	});

	// Main nav
	$('.mainnav').each(function () {
		const elem = $(this);

		// Needed logic comes here

		$(elem).addClass('init');
	});

	// Content
	//

	// Scroll
	// @todo: is this neccessary?
	//scroll();
}

// Load (Document ready)
//

window.bLazy = null;
function load(box) {
	if (enviroment === 'dev') {
		console.log('load');
	}

	// General
	//

	// Breakpoint
	// @todo: is this necessary? exist also in init function!
	//window.breakpoint = detectBreakpoint();

	// Blazy
	if(typeof(Blazy) != 'undefined') {
		const breakpoints = [
			{
				width: 420,
				src: 'data-src-xs',
				ratio: 'data-ratio-xs'
			},
			{
				width: 640,
				src: 'data-src-sm',
				ratio: 'data-ratio-sm'
			},
			{
				width: 1080,
				src: 'data-src-md',
				ratio: 'data-ratio-md'
			},
			{
				width: 1440,
				src: 'data-src-lg',
				ratio: 'data-ratio-lg'
			}
		];

		$('.b-lazy', box).each(function() {
			let ratio = false;
			let elem = this;

			$.each(breakpoints, function(k, v) {
				if(v.width >= screen.width && typeof $(elem).attr(v.ratio) !== 'undefined' && $(elem).attr(v.ratio).indexOf('x') !== -1) {
					ratio = v.ratio;
				}
			});

			if(ratio !== false) {
				let imgRatio = $(this).attr(ratio);
				imgRatio = imgRatio.split('x');
				$(this).attr('src', "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 "+imgRatio[0]+" "+imgRatio[1]+"' width='"+imgRatio[0]+"' height='"+imgRatio[1]+"'></svg>");
			}
		});

		window.bLazy = new Blazy({
			// selector: 'img', // all images
			breakpoints: breakpoints,
			success: function(element){
				setTimeout(function() {
					$(element).removeClass('b-lazy').parent().removeClass('childLoading');
				}, 200);
			},
			error: function(elem, msg) {
				if(msg === 'missing') {
					console.warn(elem, 'data-src is missing');
				}
				else if(msg === 'invalid') {
					if($(elem).attr('data-src')) {
						$(elem).removeAttr('data-src');
					}
				}
			}
		});
	}

	// Layout
	//

	// Tabs
	initTabs($('.tabs-container', box));

	/* init datepicker */
	$('.traveldatespicker', box).each(function() {
		let datePicker = new DatePicker();
		datePicker.init(this);
	});

	// Headermedia
	if ($('#headermedia').length > 0) {
		const elem = $('#headermedia', box);
		const config = {
			effect: 'fade',
			direction:'horizontal',
			autoplay: {
				delay: 4000,
				disableOnInteraction: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			loop: false,
			rewind: true,
		}
		let headermedia = new Slider(elem, config);
	}

	// Content
	//

	// Articles

	// Vievport animation
	$('.viewport').addClass('viewport-initialized');

	// Articlestandard mediaslider
	if ($('.articlestandard .articlemedia:has(.swiper-container)', box).length > 0) {
		const config = {
			autoplay: false,
			loop: true,
		};
		$('.articlestandard .articlemedia:has(.swiper-container)', box).each(function () {
			let articlestandard = new Slider($(this), config);
		});
	}

	/* article card slider */
	$('.articlecard.slider-card').each(function () {
		const $wrapper = $(this).find('.swiper-wrapper');
		let slidesCount = $wrapper.find('.swiper-slide').length;

		// Se ci sono meno di 5 slide, duplica gli elementi per garantire il loop
		if (slidesCount > 0 && slidesCount <= 3) {
			const $slides = $wrapper.find('.swiper-slide').clone();
			$wrapper.append($slides);
			slidesCount = $wrapper.find('.swiper-slide').length; // Aggiorna il conteggio totale
		}
		const config = {
			slidesPerView: 2,
			loop: true,
			autoplay: false,
			speed: 800,
			updateOnWindowResize: true,
			spaceBetween: 28,
			grabCursor: true,

			breakpoints: {
				1441: {
					slidesPerView: 2,
					spaceBetween: 28,
				},
				1081: {
					slidesPerView: 2,
					spaceBetween: 28,
				},
				641: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				421: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				0: {
					slidesPerView: 1,
					spaceBetween: 14,
				}
			},
			scrollbar: {
				el: $(this).find('.swiper-scrollbar').get(0),
				draggable: true,
				enabled: true,
				dragSize: 50,
			},
			on: {
				slideChangeTransitionStart: function () {
					const swiper = this;
					// Forza Swiper a ricalcolare le posizioni delle slide mentre cambiano larghezza
					setTimeout(() => {
						swiper.update();
					}, 50);
				},
			},
		};

		let cardSlider = new Slider($(this), config);
	});

	/* articlecard mediaslider */
	$('.articleteaser.card', box).each(function () {
		const elem = $(this, box);
		const config = {
			slidesPerView: 'auto',
			autoplay: false,
			loop: true,
			scrollbar: {
				el: $(this).find('.swiper-scrollbar').get(0),
				draggable: true,
				enabled: true,
				dragSize: 50,
			},
		};
		let articlecard = new Slider($(this), config);
	});

	// Articlegallery slider
	if ($('.articlegallery.slider', box).length > 0) {
		const config = {
			autoplay: false,
			loop: true,
		};
		$('.articlegallery.slider', box).each(function () {
			let articlegallery = new Slider($(this), config);
		});
	}

	// Scroll
	scroll(box);

	// Resize
	// @todo: is this necessary?
	//resize(true, true, box);

	// Anchor (hash) autoscroll
	if (window.location.hash.indexOf('#c') != -1) {
		let href = window.location.href.split('#c');
		// timeout to prevent layout shift after inizialisation of specific elements like accordion
		let timeout = 1500;
		if ($('#ce' + href[1], box).length > 0) {
			scrollToElement($('#ce' + href[1], box), { timeout: timeout });
		} else if ($('#c' + href[1]).length > 0) {
			scrollToElement($('#c' + href[1], box), { timeout: timeout });
		} else {
			return false;
		}
	} else if($(location.hash).length > 0) {
		scrollToElement($(location.hash));
	}
}

// Scroll
//
function scroll(box = document.body) {
	if (window.enviroment === 'dev') {
		console.info('scroll');
	}

	const scrollPosition = $(window).scrollTop();
	const scrollPositionBottom = scrollPosition + $(window).outerHeight();
	let scrollDirection = lastScrollDirection;

	$('body').css('--scroll-position', `${scrollPosition}px`);

	// Directions
	//

	if (scrollPosition > lastScrollPosition) {
		// Scrolling down
		if (lastScrollDirection === 'up') {
			lastScrollDirectionChangePosition = lastScrollPosition;
		}
		if (scrollPosition - lastScrollDirectionChangePosition >= 10) {
			scrollDirection = 'down';
		}
	} else if (scrollPosition < lastScrollPosition) {
		// Scrolling up
		if (lastScrollDirection === 'down') {
			lastScrollDirectionChangePosition = lastScrollPosition;
		}
		scrollDirection = 'up';
	}
	lastScrollDirection = scrollDirection;

	// Viewport
	//

	let previousElement = 'undefined';
	let delay = 5000;
	$('.viewport:not(.is-in-viewport)').each(function () {
		let additionalOffset = 0;
		if (!$(this).hasClass('real-viewport')) {
			additionalOffset = $(window).outerHeight() / 3;
		}
		let itemOffset = $(this).offset().top - additionalOffset;
		let itemOffsetBottom = $(this).offset().top + $(this).outerHeight();
		if (scrollPositionBottom >= itemOffset && scrollPosition < itemOffsetBottom) {
			// @todo: add delay with attr or css class for same childs on same height
			$(this).addClass('is-in-viewport');
			setTimeout(function () {
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			}, 500);
		}
	});

	// Pause/Play video
	$('.video.init').each(function () {
		let itemOffset = $(this).offset().top - ($(window).outerHeight() / 3);
		let itemOffsetBottom = $(this).offset().top + $(this).outerHeight();

		if (itemOffset < scrollPositionBottom && itemOffsetBottom > scrollPosition && $(this).hasClass('resume')) {
			Video.play($(this));
			$(this).removeClass('resume');
		} else if ((itemOffset >= scrollPositionBottom || itemOffsetBottom <= scrollPosition) && $(this).hasClass('playing')) {
			Video.pause($(this));
			$(this).addClass('resume');
		}
	});

	// Scroll classes
	//

	// Body
	if (scrollPosition > 0 || ($('body').hasClass('noheader') && scrollPosition > 100 && !$('body').hasClass('scroll'))) {
		$('body').addClass('scroll');
		if (scrollDirection == 'up' && !$('body').hasClass('scroll-to-element')) {
			$('body').addClass('scroll-upwards');
		} else if ($('body').hasClass( 'scroll-upwards')) {
			$('body').removeClass('scroll-upwards');
		}
	} else {
		$('body').removeClass('scroll scroll-upwards');
	}

	// Header
	if (scrollPosition > headerScrollOffset) {
		if($('#header').hasClass('scroll') === false) {
			$('#header').addClass('scroll');
			setTimeout(function() {
				recalcScrollHeight();
			}, 500);
		}
	} else {
		if($('#header').hasClass('scroll') === true) {
			$('#header').removeClass('scroll');
			setTimeout(function() {
				recalcScrollHeight();
			}, 500);
		}
	}

	// Sticky top
	$('div[class*="sticky-top"]').each(function () {
		let offset = $(this).offset().top - parseInt($(this).css('top'));
		if (scrollPosition >= offset && !$(this).hasClass('scroll')) {
			$(this).addClass('scroll');
		} else if (scrollPosition < offset && $(this).hasClass('scroll')) {
			$(this).removeClass('scroll');
		}
	});

	// Set last scroll position
	lastScrollPosition = scrollPosition;
}

// Passive scroll event listener
let scrollTicking = false;
function requestScrollUpdate(box = document.body) {
	if (scrollTicking) {
		return;
	}
	scrollTicking = true;
	window.requestAnimationFrame(function () {
		scroll(box);
		scrollTicking = false;
	});
}

document.addEventListener('scroll', function () {
	if (window.enviroment === 'dev') {
		// console.info('document scroll');
	}

	requestScrollUpdate();
}, passiveSupport() ? { passive: true } : false);

// Passive scroll event listener for scroll containers
let bLazyRevalidateTimeout = null;
document.querySelectorAll('.scrollcontainer').forEach(function (elem) {
	elem.addEventListener('scroll', function () {
		if (window.enviroment === 'dev') {
			// console.info('scrollcontainer scroll');
		}

		window.clearTimeout(bLazyRevalidateTimeout);
		bLazyRevalidateTimeout = window.setTimeout(function () {
			if (typeof window.bLazy?.revalidate === 'function') {
				window.bLazy.revalidate();
			}
		}, 100);
	}, passiveSupport() ? { passive: true } : false);
});


// ScrollToElement
function scrollToElement(elem, { speed = 1000, referenceContainer, timeout = 0, additionalOffset = 50 } = {}) {
	if($(elem).length === 0) {
		return;
	}

	setTimeout(function () {
		let offset = $(elem).offset().top;

		if (!referenceContainer) {
			referenceContainer = $('html, body');
		} else {
			offset = $(elem).position().top + $(referenceContainer).scrollTop();
		}

		offset -= additionalOffset;

		let fixedOffset = window.scrollOffset;

		// Inversible offset for sticky elements in fullscreen container
		let inverseOffset = 0;
		if ($(elem).closest('.fullscreen-container').length > 0 && $(elem).closest('.fullscreen-container').find('div[class^="sticky-"][class*="-top"]').length > 0) {
			let stickyTopElements = $(elem).closest('.fullscreen-container').find('> div[class^="sticky-"][class*="-top"]');
			$(stickyTopElements).each(function() {
				if ($(this).css('position') === 'sticky') {
					inverseOffset += $(this).outerHeight();
				}
			});
			offset -= inverseOffset;
		}

		if (offset < headerScrollOffset) {
			offset -= fixedOffset;
		}

		$(referenceContainer).stop(true, true).animate({scrollTop: offset}, {duration: speed, start: function() {
				$(referenceContainer).addClass('scroll-to-element');
			},
			complete: function() {
				setTimeout(function() {
					$(referenceContainer).removeClass('scroll-to-element');
				}, 300);
			}
		});
	}, timeout);
}

// Recalc scroll height
function recalcScrollHeight() {
	window.scrollOffset = 0;
	$('[data-formwidget="offset"]').each(function() {
		window.scrollOffset += $(this).outerHeight();
	});
}

// Recalc sticky top height
function recalcStickyTopHeight() {
	const stickySelector = '.sticky-top, .sticky-sm-top, .sticky-md-top, .sticky-lg-top, .sticky-xl-top, .sticky-xxl-top';
	const containerSelector = '.article, .fullscreen, .fullscreen-container';

	const containerHeights = new Map();

	$(stickySelector).each(function () {
		const $sticky = $(this);
		const $container = $sticky.closest(containerSelector);

		if (!$container.length) {
			return;
		}

		const container = $container.get(0);
		const height = $sticky.outerHeight();
		const currentHeight = containerHeights.get(container) || 0;

		containerHeights.set(container, currentHeight + height);
	});

	containerHeights.forEach(function (height, container) {
		$(container).css('--sticky-top-height', height + 'px');
	});
}

// Resize
//

function resize(widthResize = false, heightResize = false, box = document) {
	const $window = $(window);
	const $box = $(box);

	const hasFullResize = widthResize && heightResize;

	if (window.enviroment === 'dev') {
		console.info('resize');
	}

	windowWidth = $window.innerWidth();
	windowHeight = $window.innerHeight();

	if (hasFullResize) {
		getScrollHeight();
		getStickyTopHeight();

		window.breakpoint = detectBreakpoint();

		// @todo: close navigation
	}

	if (widthResize) {
		CssCalc.refresh();
	}

	recalcResizeLayout($box);
}

function recalcResizeLayout($box) {
	recalcScrollHeight();
	recalcStickyTopHeight();

	recalcHeaderMinHeight();
}


// Ready
//
$(document).ready(function(){
	if (window.enviroment === 'dev') {
		console.info('ready');
	}

	load();
});


// Mouseup
//
$(document).mouseup(function(e) {
	handleNavOutsideClick(e);
});

function handleNavOutsideClick(e) {
	let container = $(".headertop, .fullscreenmenu, #headerbottom, .mainnav");
	if (!container.is(e.target) && container.has(e.target).length === 0) {
		if($('body').hasClass('menuopen') === true) {
			closeMenu();
			closeAllOpenFullscreenMenus();
		}
	}
}

// Resize event listener
//

let resizeEndTimer = null;

let lastKnownWindowWidth = window.innerWidth;
let lastKnownWindowHeight = window.innerHeight;

$(window).on('resize', function () {
	clearTimeout(resizeEndTimer);

	resizeEndTimer = setTimeout(function () {
		const currentWindowWidth = window.innerWidth;
		const currentWindowHeight = window.innerHeight;

		const widthResize = lastKnownWindowWidth !== currentWindowWidth;
		const heightResize = lastKnownWindowHeight !== currentWindowHeight;

		if (!widthResize && !heightResize) {
			return;
		}

		lastKnownWindowWidth = currentWindowWidth;
		lastKnownWindowHeight = currentWindowHeight;

		windowWidth = currentWindowWidth;
		windowHeight = currentWindowHeight;

		if (window.enviroment === 'dev') {
			console.info('window resize');
		}

		resize(widthResize, heightResize);
	}, 150);
});


// Functions library
//

// Detect enviroment
function detectEnviroment() {
	const hostname = window.location.hostname || '';

	if (/^(localhost|dev|ddev)(\.|$)|\.ddev\./.test(hostname)) {
		return 'dev';
	}
	return 'live';
}

// Get scrollheight
function getScrollHeight() {
	recalcScrollHeight();
}

// Get sticky top height
function getStickyTopHeight() {
	recalcStickyTopHeight();
}
/* END get scroll height with offset */

// Detect breakpoint
function detectBreakpoint() {
	let breakpoint;
	const prevBreakpoint = window.breakpoint;

	/* check if bootstrap display class is not none */
	if($('body > span.d-xxl-block').css('display') != 'none') {
		breakpoint = 'xxl';
	} else if($('body > span.d-xl-block').css('display') != 'none') {
		breakpoint = 'xl';
	} else if($('body > span.d-lg-block').css('display') != 'none') {
		breakpoint = 'lg';
	} else if($('body > span.d-md-block').css('display') != 'none') {
		breakpoint = 'md';
	} else if($('body > span.d-sm-block').css('display') != 'none') {
		breakpoint = 'sm';
	} else if($('body > span.d-block').css('display') != 'none') {
		breakpoint = 'xs';
	}

	/* add breakpoint class to body */
	if (!$('body').hasClass(breakpoint)) {
		$('body').removeClass('xxl xl lg md sm xs').addClass(breakpoint);
	}

	if (prevBreakpoint !== breakpoint) {
		$(window).trigger('breakpoint:change', [breakpoint, prevBreakpoint]);
	}

	return breakpoint;
}

function bpIndex(bp) {
	const i = window.breakpoints.indexOf(bp);
	return i === -1 ? 0 : i;
}

// Breakpoint change event listener
$(window).on('breakpoint:change', function (e, bp, prev) {
	if (window.enviroment === 'dev') {
		console.info('breakpoint:change');
	}

	// Text collapse
	const collapseText = $('[class*="text-collapse-"], [class*="text-xs-collapse-"], [class*="text-sm-collapse-"], [class*="text-md-collapse-"], [class*="text-lg-collapse-"], [class*="text-xl-collapse-"], [class*="text-xxl-collapse-"]');
	if (collapseText && collapseText.length && typeof textCollapse === 'function') {
		textCollapse(collapseText);
	}
});

/* datepicker (http://lopezb.com/hoteldatepicker/) */
var allDatepickers = [];
const DatePicker = function() {
	let outerThis = this;
	this.input = null;
	this.datepickerObj = null;

	this.arrivalInputName = 'dayfrom_submit';
	this.departureInputName = 'dayuntil_submit';
	this.defaultDayOfWeek = 6;

	this.settings = {
		format: 'DD.MM.YYYY',
		//format: 'ddd, DD. MMM YYYY',
		formatCallback: 'YYYY-MM-DD',
		selectForward: true,
		moveBothMonths: true,
		autoClose: true,
		closeOnClick: true,
		animationSpeed: '0',
		hoveringTooltip: function() {}, // Datepicker Tooltip überschreiben
		nextText: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>',
		prevText: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>',
		/*
		noCheckInDates: [
			'2019-05-26',
			'2019-06-02'
		],
		noCheckOutDates: [
			'2019-05-29',
			'2019-06-07'
		],
		*/
		tooltips: [
			/*
			{
				from: '2021-10-01',
				to: '2021-10-13',
				color: 'green',
				text: 'test...',
			},
			{
				dayOfWeek: 0, // 0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Saturday
				color: '#ef114c',
				text: 'test2',
			},
			*/
		],
		showTopbar: false,

		startOfWeek: 'monday',
		onSelectRange: function() {
			let dateRange = outerThis.datepickerObj.getUnformatetValue(); // getValue() has wrong format
			if(dateRange.length > 0) {
				outerThis.onSelectRange(dateRange[0], dateRange[1]);
			}
		},
		onClear: function() {
			outerThis.onClear();
		},
		onMonthChange: function() {
			outerThis.onMonthChange();
		},
	};
	this.translations = {
		'deu': {
			selected: 'Dein Aufenthalt:',
			night: 'Nacht',
			nights: 'Nächte',
			buttonClose: 'Schließen',
			buttonClear: 'Löschen',
			'checkin-disabled': 'Check-in nicht möglich',
			'checkout-disabled': 'Check-out nicht möglich',
			// 'day-names-short': ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
			'day-names-short': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
			'day-names': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
			'month-names-short': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
			'month-names': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			'error-less': 'Sie müssen mindestens eine Übernachtung auswählen',
			'error-less-plural': 'Sie müssen mindestens %d Übernachtungen auswählen',
			'info-default': 'Bitte die Nächtigungen auswählen',
			'messaggeArrival': 'Anreise wählen',
			'messaggeDeparture': 'Abreise wählen',
			'messaggeChangeDates': 'Reisedaten ändern',
		},
		'eng': {
			selected: 'Your stay:',
			night: 'Night',
			nights: 'Nights',
			buttonClose: 'Close',
			buttonClear: 'Clear',
			'checkin-disabled': 'Check-in disabled',
			'checkout-disabled': 'Check-out disabled',
			'day-names-short': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			'day-names': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			'month-names-short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			'error-more': 'Date range should not be more than 1 night',
			'error-more-plural': 'Date range should not be more than %d nights',
			'error-less': 'Date range should not be less than 1 night',
			'error-less-plural': 'Date range should not be less than %d nights',
			'info-more': 'Please select a date range of at least 1 night',
			'info-more-plural': 'Please select a date range of at least %d nights',
			'info-range': 'Please select a date range between %d and %d nights',
			'info-default': 'Please select a date range',
			'messaggeArrival': 'Choose arrival',
			'messaggeDeparture': 'Choose departure',
			'messaggeChangeDates': 'Change travel dates',
		},
		'ita': {
			selected: 'Il tuo soggiorno:',
			night: 'Notte',
			nights: 'Notti',
			buttonClose: 'Chiudi',
			buttonClear: 'Cancella',
			'checkin-disabled': 'Check-in disabilitato',
			'checkout-disabled': 'Check-out disabilitato',
			// 'day-names-short': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
			'day-names-short': ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
			'day-names': ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
			'month-names-short': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
			'month-names': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
			'error-more': 'L\'intervallo di date non deve avere più di 1 notte',
			'error-more-plural': 'L\'intervallo di date non deve avere più di %d notti',
			'error-less': 'L\'intervallo di date non deve avere meno di 1 notte',
			'error-less-plural': 'L\'intervallo di date non deve avere meno di %d notti',
			'info-more': 'Per favore seleziona un intervallo di date maggiore di 1 notte',
			'info-more-plural': 'Per favore seleziona un intervallo di date maggiore di %d notti',
			'info-range': 'Per favore seleziona un intervallo di date tra %d e %d notti',
			'info-default': 'Per favore seleziona un intervallo di date',
			'messaggeArrival': 'Scegli data d\'arrivo',
			'messaggeDeparture': 'Scegli data di partenza',
			'messaggeChangeDates': 'Cambia le date del soggiorno',
		},
	};

	this.setTranslations = function(l) {
		if(typeof this.translations[l] === 'undefined') {
			l = 'eng';
		}
		this.settings.i18n = this.translations[l];
	};

	this.init = function(input) {
		input = $(input).get(0);
		if(input === null) {
			return;
		}
		this.input = input;

		let settings = this.settings;
		this.setTranslations(lang);

		let tmpDatepicker = new HotelDatepicker(this.input, settings);
		// tmpDatepicker.open();
		let id = tmpDatepicker.getDatepickerId();
		allDatepickers[id] = tmpDatepicker;
		this.datepickerObj = tmpDatepicker;

		this.setDefaultDate();
	};

	this.setDefaultDate = function() {
		// preset always sat at sat
		let defaultStartDate = this.findNextWeekday();
		let defaultEndDate = new Date(defaultStartDate.getTime());
		defaultEndDate.setDate(defaultEndDate.getDate() + 7);

		/*
		let today =  new Date();
		let weekday = today.getDay();
		let currentDayOffset = 1;
		if (weekday === 0) { // if is sunday
			currentDayOffset = 6 - weekday;
		}
		let nextWeekDayOffset = currentDayOffset + 7;
		let currentDate = new Date();
		currentDate.setDate(currentDate.getDate() + currentDayOffset);
		let nextWeekDate = new Date();
		nextWeekDate.setDate(nextWeekDate.getDate() + nextWeekDayOffset);
		*/

		// set values
		this.onSelectRange(
			fecha.format(defaultStartDate, this.settings.formatCallback),
			fecha.format(defaultEndDate, this.settings.formatCallback)
		);
		$(this.input).val(fecha.format(defaultStartDate, this.settings.format) + ' - ' + fecha.format(defaultEndDate, this.settings.format));
	};

	this.findNextWeekday = function(dayOfWeek) {
		if(typeof dayOfWeek === 'undefined' || (dayOfWeek < 0 || dayOfWeek > 6)) {
			dayOfWeek = this.defaultDayOfWeek;
		}

		for(let i = 0; i < 7; i++) {
			let currentDate = new Date();
			currentDate.setDate(currentDate.getDate() + i);
			if(currentDate.getDay() === dayOfWeek) {
				return currentDate;
			}
		}

		return new Date();
	};

	this.onSelectRange = function(startDate, endDate) {
		let currentForm = $(this.input).closest('form');

		currentForm.find('[name="'+this.arrivalInputName+'"]').val(startDate);
		currentForm.find('[name="'+this.departureInputName+'"]').val(endDate);
		currentForm.find('[name="arrival"]').val(startDate);
		currentForm.find('[name="departure"]').val(endDate);

		let parsedStartDate = fecha.parse(startDate, this.settings.formatCallback);
		let parsedEndDate = fecha.parse(endDate, this.settings.formatCallback);

		currentForm.find('[data-arrival-format]').each(function() {
			let format = $(this).attr('data-arrival-format');
			$(this).html(fecha.format(parsedStartDate, format));
		});
		currentForm.find('[data-departure-format]').each(function() {
			let format = $(this).attr('data-departure-format');
			$(this).html(fecha.format(parsedEndDate, format));
		});
	};

	this.onMonthChange = function() {
		// todo: finish
		if(this.settings.tooltips.length > 0 && typeof $.fn.tooltip !== 'undefined') {
			$('.rangedatepicker .datepicker__month-day[title]').tooltip({
				container: 'body',
				placement: 'top',
			});
		}
	};

	this.onClear = function() {
		let currentForm = $(this.input).closest('form');
		currentForm.find('[name="'+this.arrivalInputName+'"]').val('');
		currentForm.find('[name="'+this.departureInputName+'"]').val('');
		currentForm.find('[name="arrival"]').val('');
		currentForm.find('[name="departure"]').val('');

		$('.shortrequest .smartphone-datepicker').removeClass('selected');
		this.setDefaultDate();
	};

};
/* END datepicker */

// Repeat elements
const Repeatable = function() {
	this.init = function(box) {
		let outerThis = this;
		$('.repeatablewrapper', box).each(function() {
			let containerElement = $(this).find('.repeatablecontainer');
			let draftElement = $(this).find('.repeatabledraft');
			$(this).find('.removerepeatable').click(function() {
				outerThis.remove(containerElement, draftElement);
			});
			$(this).find('.addrepeatable').click(function() {
				outerThis.add(containerElement, draftElement);
			}).click();
		});
	};

	this.add = function(containerElement, draftElement) {
		let copiedElement = draftElement.html();
		containerElement.append(copiedElement);

		this.onChange(containerElement);
	};

	this.remove = function(containerElement, draftElement) {
		containerElement.find('.repeatableitem').last().remove();

		this.onChange(containerElement);
	};

	this.onChange = function(containerElement) {
		containerElement.find('.repeatableitem').each(function(k, v) {
			let oldIndex = $(this).attr('data-repeatable-index');
			$(this).attr('data-repeatable-index', k);

			$(this).find('input, select, [data-for], .num').each(function() {
				if($(this).attr('name') && $(this).attr('name').indexOf('['+oldIndex+']') !== -1) {
					let newName = $(this).attr('name').replace('['+oldIndex+']', '['+k+']');
					$(this).attr('name', newName);
					if($(this).closest('.childage').length === 0) {
						$(this).removeAttr('disabled');
					}
				} else if($(this).attr('data-for') && $(this).attr('data-for').indexOf('['+oldIndex+']') !== -1) {
					let newName = $(this).attr('data-for').replace('['+oldIndex+']', '['+k+']');
					$(this).attr('data-for', newName);
				} else if($(this).hasClass('num')) {
					$(this).html(k + 1);
				}
			});
		});

		let maxItems = containerElement.attr('data-repeatable-max');
		if(containerElement.find('.repeatableitem').length >= maxItems) {
			containerElement.closest('.repeatablewrapper').find('.addrepeatable').hide();
		} else {
			containerElement.closest('.repeatablewrapper').find('.addrepeatable').show();
		}

		if(containerElement.find('.repeatableitem').length <= 1) {
			containerElement.closest('.repeatablewrapper').find('.removerepeatable').hide();
		} else {
			containerElement.closest('.repeatablewrapper').find('.removerepeatable').show();
		}
	};
};

// Slider
//

window.Slider = function (elem, config = {}, events = {}) {
	// set elem
	this.elem = elem;

	// find swiper-container for initialation
	this.sliderContainer = $(this.elem);
	if (!$(this.sliderContainer).hasClass('swiper-container')) {
		this.sliderContainer = $(this.sliderContainer).find('.swiper-container');
		if ($(this.sliderContainer).length <= 0) {
			if ($(this.sliderContainer).find('div[class*="-container"]').length > 0 && $(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"]').length > 0 && $(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"] > div[class*="-items"]').length > 0) {
				$(this.elem).addClass('js-manipulated-swiper');
				this.sliderContainer = $(this.sliderContainer).find('div[class*="-container"]').addClass('swiper-container');
				$(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"]').addClass('swiper-wrapper');
				$(this.sliderContainer).find('div[class*="-container"] > div[class*="-wrapper"] > div[class*="-items"]').addClass('swiper-slide');
				console.info('better usage is as server side rendered slider:', this.elem);
			} else {
				console.info('no swiper container found for element:', this.elem);
				return false;
			}
		}
	}

	this.sliderWrapper = $(this.sliderContainer).find('.swiper-wrapper').first();

	// preset & set if slider data exist
	this.slider;
	if (typeof $(this.elem).data('slider') !== 'undefined') {
		this.slider = $(this.elem).data('slider');
	}

	// preset & set if slider item data exist
	this.countItems = 0;
	if (typeof $(this.sliderContainer).data('items') !== 'undefined') {
		this.countItems = $(this.sliderContainer).data('items');
	}

	// Get config as data attribute
	try {
		this.dataConfig = $(this.sliderContainer).data('config')
			? JSON.parse(
				$(this.sliderContainer).data('config')
					.replace(/'/g, '"')
					.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":')
			)
			: {};
	} catch (error) {
		this.dataConfig = {};
		console.error('Ungültiges data-config Format:', $(this.sliderContainer).data('config'), error);
	}

	this.config = {
		default: {
			effect: 'slide', // 'slide' | 'fade' | 'cube' | 'coverflow' | 'flip'
			loop: false,
			rewind: false,
			keyboard: false,
			spaceBetween: 0,
			slidesPerView: 1,
			//maxSlidesPerView: 1,
			speed: 1000,
			autoplay: false,
			centeredSlides: false,
			allowTouchMove: true,
			parallax: false,
			touchEventsTarget: 'container',
			// Disable original resize observer/window resize
			resizeObserver: false,
			updateOnWindowResize: false,
		},
		passed: config,
		data: this.dataConfig,
	};

	this.controls = {
		default: {
			navigation: {
				nextEl: $(this.elem).find('.swiper-button-next').get(0),
				prevEl: $(this.elem).find('.swiper-button-prev').get(0),
			},
			pagination: {
				el: $(this.elem).find('.swiper-pagination').get(0),
				type: 'fraction',
				formatFractionCurrent: function (number) {
					return prependZero(number);
				},
				formatFractionTotal: function (number) {
					return prependZero(number);
				},
				renderFraction: function (currentClass, totalClass) {
					return '<div class="' + currentClass + '"></div>' +
						'<div class="' + totalClass + '"></div>';
				}
			},
		}
	}

	this.events = {
		default: {
			init: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}

				// check first slide
				let firstSlide = swiper.slides[0];

				// check next slide for video slide
				let restartAutoplay = false;
				if (typeof swiper.params.autoplay.enabled !== 'undefined' && swiper.params.autoplay.enabled !== false) {
					restartAutoplay = true;
				}
				if (swiper.slides[1]) {
					let nextSlide = swiper.slides[1];
					if ($(nextSlide).hasClass('video-slide')) {
						restartAutoplay = false;
					}
				}

				// check if first slide is video slide
				if ($(firstSlide).hasClass('video-slide')) {
					let video = $(firstSlide).find('.video');
					if ($(video).length > 0) {
						let videoSettings = {
							callback: {
								play: function () {
									swiper.autoplay.stop();
								},
								ended: function () {
									swiper.slideNext();
									if (restartAutoplay) {
										swiper.autoplay.start();
									}
									Video.stop(video);
								}
							}
						};
						if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
							swiper.autoplay.stop();
							Video.play(video, videoSettings);
						} else if (!$(video).hasClass('init')) {
							Video.init(video, videoSettings);
						}
					}
				}

				if (typeof swiper.params.slidesPerView !== 'undefined' && swiper.params.slidesPerView > 1) {
					if (typeof swiper.slides !== 'undefined' && swiper.slides.length > 0) {
						for (let i = 0; i < swiper.slides.length; i++) {
							let slide = swiper.slides[i];
							if ($(slide).length > 0 && $(slide).hasClass('video-slide')) {
								let video = $(slide).find('.video');

								let videoSettings = {
									callback: {
										play: function () {
											swiper.autoplay.stop();
										},
										ended: function () {
											swiper.slideNext();
											if (restartAutoplay) {
												swiper.autoplay.start();
											}
											Video.stop(video);
										}
									}
								};
								if (!$(video).hasClass('init')) {
									Video.init(video, videoSettings);
								}
							}
						}
					}
				}
			},
			slideChange: function(swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}

				// get active & prev slide
				let activeIndex = swiper.activeIndex;
				let previousIndex = swiper.previousIndex;
				let activeSlide = swiper.slides[activeIndex];
				let previousSlide = swiper.slides[previousIndex];

				// check next slide for video slide
				let restartAutoplay = false;
				if (typeof swiper.params.autoplay.enabled !== 'undefined' && swiper.params.autoplay.enabled !== false) {
					restartAutoplay = true;
				}
				if (swiper.slides[activeIndex + 1]) {
					let nextSlide = swiper.slides[activeIndex + 1];
					if ($(nextSlide).hasClass('video-slide')) {
						restartAutoplay = false;
					}
				}

				// check if active slide is video slide
				if ($(activeSlide).hasClass('video-slide')) {
					let video = $(activeSlide).find('.video').get(0);
					if ($(video).length > 0) {
						let videoSettings = {
							callback: {
								play: function () {
									swiper.autoplay.stop();
								},
								ended: function () {
									swiper.slideNext();
									if (restartAutoplay) {
										swiper.autoplay.start();
									}
									Video.stop(video);
								}
							}
						};

						if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
							swiper.autoplay.stop();
							Video.play(video, videoSettings);
						} else if (!$(video).hasClass('init')) {
							Video.init(video, videoSettings);
						}
					}
				}

				// check if previous slide is video slide
				if ($(previousSlide).hasClass('video-slide')) {
					let video = $(previousSlide).find('.video').get(0);
					if ($(video).attr('autoplay') && $(video).attr('autoplay') !== 'false') {
						swiper.autoplay.stop();
					}
					Video.pause(video);
				}
			},
			slideChangeTransitionEnd: function (swiper) {
				// lazyload is enabled
				if (typeof window.bLazy?.revalidate === 'function') {
					window.bLazy.revalidate();
				}
			},
		},
		passed: events,
		data: (typeof $(this.sliderContainer).data('events') !== 'undefined') ? $(this.sliderContainer).data('events') : {},
	};

	$(this.elem).data('events', this.events.passed);

	this.parameter = {};

	this.init = function(config, events) {
		// merged config to parameter
		this.parameter = this.mergeConfig();

		// add events to parameter
		this.parameter['on'] = this.mergeEvents(events);

		// check if default controls are necessary
		// check and set navigation
		if (typeof this.parameter.navigation === 'undefined' && typeof this.controls.default.navigation !== 'undefined' && $(this.sliderContainer).find($(this.controls.default.navigation.prevEl)).length > 0 && $(this.sliderContainer).find($(this.controls.default.navigation.nextEl)).length > 0) {
			this.parameter['navigation'] = this.controls.default.navigation;
		}

		// check and set navigation
		if (typeof this.parameter.pagination === 'undefined' && typeof this.controls.default.pagination !== 'undefined' && $(this.sliderContainer).find($(this.controls.default.pagination.el)).length > 0) {
			this.parameter['pagination'] = this.controls.default.pagination;
		}

		// init swiper
		if (typeof Swiper !== 'undefined') {
			// Before initialization: ensure original indexing and filter out hidden slides for current breakpoint
			this.restoreAllSlides();
			this.removeHiddenSlides();

			// count items/slides and modifiy default behaviour
			this.countItems = $(this.elem).find('.swiper-slide').length;
			$(this.sliderContainer).attr({'data-items': this.countItems});

			// Support maxSlidesPerView: cap slidesPerView to the number of slides
			// Usage: pass { maxSlidesPerView: N } at root or inside breakpoints; when present and
			// slidesPerView is not explicitly set, it will be computed as min(N, countItems).
			// If slidesPerView is set, it will be capped to maxSlidesPerView and countItems.
			if (typeof this.parameter === 'object' && this.parameter) {
				// Base params
				if (typeof this.parameter.maxSlidesPerView !== 'undefined') {
					let maxBase = Number(this.parameter.maxSlidesPerView);
					if (!isNaN(maxBase) && maxBase > 0) {
						let baseSpv =  maxBase;
						// Ensure numeric
						baseSpv = Number(baseSpv);
						if (!Number.isFinite(baseSpv) || baseSpv <= 0) {
							baseSpv = 1;
						} else {
							baseSpv = Math.round(baseSpv * 100) / 100;
						}
						this.parameter.slidesPerView = Math.min(maxBase, this.countItems, baseSpv);
					}
				}
				// Breakpoints params
				if (typeof this.parameter.breakpoints === 'object' && this.parameter.breakpoints) {
					Object.keys(this.parameter.breakpoints).forEach((bp) => {
						let cfg = this.parameter.breakpoints[bp];
						if (cfg && typeof cfg.maxSlidesPerView !== 'undefined') {
							let maxBp = Number(cfg.maxSlidesPerView, 10);
							if (!isNaN(maxBp) && maxBp > 0) {
								let bpSpv = maxBp;
								bpSpv = Number(bpSpv, 10);
								if (!Number.isFinite(bpSpv) || bpSpv <= 0) {
									bpSpv = 1;
								} else {
									bpSpv = Math.round(bpSpv * 100) / 100;
								}
								cfg.slidesPerView = Math.min(maxBp, this.countItems, bpSpv);
							}
						}
					});
				}
			}

			// check for videos
			this.videosInSlider = $(this.sliderContainer).find('.swiper-slide.video-slide');

			// check for videos
			this.youTubeVideoInSlider = $(this.sliderContainer).find('.swiper-slide.video-slide .youtube-video-container').length;

			// video consent required (actually build only with gnconsent)
			if (consentToolActive) {
				let youTubeConsent = true;
				if (consentTool === 'gnConsent' && gnConsent.getConsent('youTube') !== null && gnConsent.getConsent('youTube') === false) {
					youTubeConsent = false;
				}
				let vimeoConsent = true;
				if (consentTool === 'gnConsent' && gnConsent.getConsent('vimeo') !== null && gnConsent.getConsent('vimeo') === false) {
					vimeoConsent = false;
				}

				// control each video slide
				let sliderContainer = this.sliderContainer;
				$(this.videosInSlider).each(function () {
					let videoSlide = $(this);
					if ($(videoSlide).find('.youtube-video-container').length > 0 && youTubeConsent === false || $(videoSlide).find('.vimeo-video-container').length > 0 && vimeoConsent === false) {
						// append video slide with no consent to the end
						$(videoSlide).appendTo($(sliderContainer).find('.swiper-wrapper'));
					}
				});
			}

			if (this.countItems <= 1) {
				this.parameter['loop'] = false;
				//this.parameter['navigation'] = false;
				//this.parameter['pagination'] = false;
				this.parameter['allowTouchMove'] = false;
			}

			// setting according to documentation (https://swiperjs.com/swiper-api#param-loop)
			if (typeof this.parameter['slidesPerView'] !== 'undefined' && this.parameter['slidesPerView'] > 1 && this.countItems < (this.parameter['slidesPerView'] * 2)) {
				this.parameter['loop'] = false;
			}

			// if youtube slide exist & loop is active bugfix with rewind
			if (this.youTubeVideoInSlider > 0 && (typeof this.parameter['loop'] !== 'undefined' && this.parameter['loop']) && (typeof this.parameter['rewind'] !== 'undefined' && !this.parameter['rewind'])) {
				this.parameter['loop'] = 0;
				this.parameter['rewind'] = true;
			}

			this.slider = new Swiper($(this.sliderContainer).get(0), this.parameter);

			// set to storage (needed for destroy an manipulation after initialisation)
			$(this.elem).data('slider', this.slider);

			// Nutze IntersectionObserver für Sichtbarkeit und ResizeObserver für Größenänderungen
			this.setupPerformanceObservers();
		} else {
			console.warn('swiper.js is not included');
			return false;
		}
	}

	this.destroy = function() {
		if (typeof Swiper !== 'undefined') {

			// Disconnect observers
			if (this.resizeObserver) this.resizeObserver.disconnect();
			if (this.intersectionObserver) this.intersectionObserver.disconnect();

			// Clear timers
			if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
			if (this.rafId) cancelAnimationFrame(this.rafId);

			// unbind breakpoint handler
			/*
			if (this.bpHandlerBound) {
				$(window).off('breakpoint:change', this.onBreakpointChange);
				this.bpHandlerBound = false;
			}
			*/

			this.slider.destroy();

			if ($(this.elem).hasClass('js-manipulated-swiper')) {
				$(this.elem).removeClass('js-manipulated-swiper');
				$(this.sliderContainer).removeClass('swiper-container');
				$(this.sliderContainer).find('.swiper-wrapper').removeClass('.swiper-wrapper');
				$(this.sliderContainer).find('.swiper-slide').removeClass('.swiper-slide');
			}
		}
	}
	this.mergeConfig = function(config = {}) {
		return {
			...this.config.default,
			...this.config.data,
			...this.config.passed,
			...config,
		};
	}
	this.mergeEvents = function(events = {}) {
		return {
			...this.events.default,
			...this.events.data,
			...this.events.passed,
			...events,
		};
	}

	// Detach/attach slides depending on visibility
	// storage for breakpoint-based hidden slides handling
	// Keep original order and track temporarily removed slides
	this.origIndexed = false; // whether original indices are set
	this.removedSlides = []; // array of { index: Number, $el: jQuery }
	//this.bpHandlerBound = false; // whether the breakpoint handler is bound

	// Mark original indices once
	this.ensureOrigIndex = () => {
		if (this.origIndexed) return;
		const slides = this.sliderWrapper.children('.swiper-slide');
		if (slides.length === 0) return;

		slides.each(function(i){
			if ($(this).hasClass('swiper-slide-duplicate')) return;
			$(this).attr('data-orig-index', i);
		});
		this.origIndexed = true;
	};

	// Check visibility
	this.isSlideVisible = (slideEl) => {
		const el = $(slideEl);
		// Always ignore swiper duplicates
		if (el.hasClass('swiper-slide-duplicate')) return true;
		return el.css('display') !== 'none';
	};

	// Restore all previously removed slides to their original positions
	this.restoreAllSlides = () => {
		if (!this.removedSlides || this.removedSlides.length === 0) return;
		// sort by original index to insert in order
		this.removedSlides.sort((a,b) => a.index - b.index).forEach(item => {
			const idx = item.index;
			const siblings = this.sliderWrapper.children('.swiper-slide').not('.swiper-slide-duplicate');
			if (siblings.length === 0 || idx >= siblings.length) {
				this.sliderWrapper.append(item.$el);
			} else {
				// insert before element currently at idx
				siblings.eq(idx).before(item.$el);
			}
		});
		this.removedSlides = [];
	};

	// Detach hidden slides based on visibility
	this.removeHiddenSlides = () => {
		this.ensureOrigIndex();
		const self = this;
		const slidesToDetach = [];

		this.sliderWrapper.children('.swiper-slide').not('.swiper-slide-duplicate').each(function(){
			const slide = $(this);
			const visible = self.isSlideVisible(slide);
			if (!visible) {
				const origIndexAttr = slide.attr('data-orig-index');
				const origIndex = typeof origIndexAttr !== 'undefined' ? parseInt(origIndexAttr, 10) : slide.index();
				slidesToDetach.push({ index: origIndex, $el: slide });
			}
		});

		if (slidesToDetach.length > 0) {
			slidesToDetach.forEach(item => {
				self.removedSlides.push({ index: item.index, $el: item.$el.detach() });
			});
		}
	};

	// Breakpoint change handler (restore, re-filter, then update swiper)
	/*
	this.onBreakpointChange = (e, breakpoint, prevBreakpoint) => {
		this.restoreAllSlides();
		this.removeHiddenSlides();

		if (this.slider && typeof this.slider.update === 'function') {
			// If loop is enabled, rebuild looped slides to reflect DOM changes
			try {
				if (this.slider.params && this.slider.params.loop && typeof this.slider.loopDestroy === 'function' && typeof this.slider.loopCreate === 'function') {
					this.slider.loopDestroy();
					this.slider.loopCreate();
				}
				this.slider.update();
				this.slider.slideTo(0);
				if (
					this.slider.params?.autoplay &&
					this.slider.params.autoplay !== false &&
					this.slider.params.autoplay.enabled !== false &&
					this.slider.autoplay &&
					typeof this.slider.autoplay.start === 'function'
				) {
					this.slider.autoplay.start();
				}
			} catch (err) {
				console.warn('Swiper update after breakpoint change failed', err);
			}
		}
	};

	this.bindBreakpointHandler = () => {
		if (this.bpHandlerBound) return;
		$(window).on('breakpoint:change', this.onBreakpointChange);
		this.bpHandlerBound = true;
	};
	*/

	this.setupPerformanceObservers = () => {
		this.isVisible = false;
		this.lastWidth = this.sliderContainer.width();

		// IntersectionObserver: update only wen visible
		this.intersectionObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				this.isVisible = entry.isIntersecting;
				if (this.isVisible && this.needsUpdate) {
					this.updateSlider();
					this.needsUpdate = false;
				}
			});
		}, {
			rootMargin: '100% 0px',
			threshold: 0.01
		});

		this.intersectionObserver.observe(this.sliderContainer.get(0));

		// ResizeObserver: Only for width changes
		this.resizeObserver = new ResizeObserver((entries) => {
			for (let entry of entries) {
				let newWidth;
				if (entry.contentBoxSize) {
					// Fallback for different browser implementations
					const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
					newWidth = contentBoxSize.inlineSize;
				} else {
					newWidth = entry.contentRect.width;
				}

				if (Math.abs(newWidth - this.lastWidth) > 1) { // 1px threshold
					this.lastWidth = newWidth;

					// Delete debounce timer
					if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);

					// Set debounce timer
					this.resizeDebounceTimer = setTimeout(() => {
						if (this.isVisible) {
							if (this.rafId) cancelAnimationFrame(this.rafId);
							this.rafId = requestAnimationFrame(() => this.updateSlider());
						} else {
							this.needsUpdate = true;
						}
						this.resizeDebounceTimer = null;
					}, 150); // Wait 150ms
				}
			}
		});

		this.resizeObserver.observe(this.sliderContainer.get(0));
	};

	this.updateSlider = () => {
		if (!this.slider || typeof this.slider.update !== 'function') return;

		// Breakpoint-Logik ausführen if neccessary
		this.restoreAllSlides();
		this.removeHiddenSlides();

		try {
			if (this.slider.params && this.slider.params.loop && typeof this.slider.loopDestroy === 'function') {
				this.slider.loopDestroy();
				this.slider.loopCreate();
			}
			this.slider.update();
		} catch (err) {
			console.warn('Slider update failed', err);
		}
	};

	// init slider
	if ($(this.sliderContainer).length > 0 && !$(this.sliderContainer).hasClass('swiper-initialized')) {
		this.init(this.config.passed, this.events.passed);
	}
}

// Videos
//

// Controller
window.Video = {
	init: function (elem, settings) {
		// get video type
		let videoType = Video.getVideoType($(elem).get(0));

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.init(elem, settings);
				break;
			case 'youtube':
				YouTubeVideo.init(elem, settings);
				break;
			case 'vimeo':
				VimeoVideo.init(elem, settings);
				break;
		}
	},
	play: function (elem, settings) {
		// get video type
		let videoType = Video.getVideoType($(elem).get(0));

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.play(elem, settings);
				break;
			case 'youtube':
				YouTubeVideo.play(elem, settings);
				break;
			case 'vimeo':
				VimeoVideo.play(elem, settings);
				break;
		}
	},
	pause: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.pause(elem);
				break;
			case 'youtube':
				YouTubeVideo.pause(elem);
				break;
			case 'vimeo':
				VimeoVideo.pause(elem);
				break;
		}
	},
	stop: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);

		// go to action
		switch (videoType) {
			case 'html':
				Html5Video.stop(elem);
				break;
			case 'youtube':
				YouTubeVideo.stop(elem);
				break;
			case 'vimeo':
				VimeoVideo.stop(elem);
				break;
		}
	},
	mute: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);
	},
	unmute: function (elem) {
		// get video type
		let videoType = Video.getVideoType(elem);
	},
	getVideoType: function (elem) {
		if ($(elem).length > 0) {
			if ($(elem).hasClass('youtube-iframe')) {
				return 'youtube';
			} else if ($(elem).hasClass('vimeo-iframe')) {
				return 'vimeo';
			} else if ($(elem).hasClass('html-video')) {
				return 'html';
			}
		}

		return false;
	},
}

// HTML5
window.Html5Video = {
	init: function (elem, settings) {
		// mark as initalized
		$(elem).addClass('init');

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('html-video')) {
			if ($(playerContainer).find('video.html-video').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('video.html-video').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('Html5 video logic needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// set status
		// set audio status
		let audioStatus = 1;
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			audioStatus = 0;
		}

		// set play status
		let playStatus = 0;
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			playStatus = 1;
			audioStatus = 0;
		}

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.html-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.html-video-container');
		}

		// get controls
		let controls;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.html-video-controls').length > 0) {
			controls = $(parentContainer).find('.video-controls.html-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				$(controls).remove();
			}
		}

		// get play button
		let playButton;
		if ($(controls).length > 0 && $(controls).find('.video-play.html-video-play').length > 0) {
			playButton = $(controls).find('.video-play.html-video-play');
			if (playStatus === 0) {
				$(playButton).addClass('paused');
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				Html5Video.togglePlayStatus(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controls).length > 0 && $(controls).find('.video-audio.html-video-audio').length > 0) {
			audioButton = $(controls).find('.video-audio.html-video-audio');
			if (audioStatus === 0) {
				$(audioButton).addClass('muted');
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				Html5Video.toggleSound(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// set default callbacks for updating status
		let defaultCallbacks = {
			'play': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 1;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).removeClass('paused visible');
					}
				}
			},
			'pause': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 2;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
			'stop': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 0;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
			'ended': function () {
				if (typeof Html5Video.storage[elemId] !== 'undefined') {
					Html5Video.storage[elemId]['playStatus'] = 0;
					if (typeof Html5Video.storage[elemId]['playButton'] !== 'undefined') {
						$(Html5Video.storage[elemId]['playButton']).addClass('paused visible');
					}
				}
			},
		}

		// set default callbacks
		Html5Video.setCallback(elem, defaultCallbacks);

		// check & set for callbacks
		if (typeof settings !== 'undefined' && typeof settings.callback !== 'undefined') {
			Html5Video.setCallback(elem, settings.callback);
		}

		// save player in storage
		Html5Video.storage[elemId] = {
			elem: elem,
			settings: settings,
			playStatus: playStatus,
			audioStatus: audioStatus,
			playButton: playButton,
			audioButton: audioButton,
		};

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.playStatus !== 'undefined') {
			if (player.playStatus === -1 || player.playStatus === 0 || player.playStatus === 2) {
				Html5Video.play(elem);
			} else {
				Html5Video.pause(elem);
			}
		}
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = Html5Video.init(elem, settings);
			return;
		}

		$(elem).addClass('playing played');

		// trigger play
		$(elem).trigger('play');
	},
	pause: function (elem) {
		$(elem).trigger('pause');

		$(elem).removeClass('playing');
	},
	stop: function (elem) {
		$(elem).trigger('stop');

		$(elem).removeClass('playing');
	},
	toggleSound: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.audioStatus !== 'undefined') {
			if (player.audioStatus === 0) {
				Html5Video.unmute(elem);
			} else {
				Html5Video.mute(elem);
			}
		}
	},
	mute: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.elem !== 'undefined' && $(player.elem).length > 0) {
			let elemId = $(player.elem).attr('id');
			$(player.elem).prop('muted', true);
			if (typeof player.audioButton !== 'undefined' && $(player.audioButton).length > 0) {
				$(player.audioButton).addClass('muted');
			}
			Html5Video.storage[elemId]['audioStatus'] = 0;
		}
	},
	unmute: function (elem) {
		if (!elem) {
			return false;
		}

		// get player
		let player = Html5Video.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.elem !== 'undefined' && $(player.elem).length > 0) {
			let elemId = $(player.elem).attr('id');
			$(player.elem).prop('muted', false);
			if (typeof player.audioButton !== 'undefined' && $(player.audioButton).length > 0) {
				$(player.audioButton).removeClass('muted');
			}
			Html5Video.storage[elemId]['audioStatus'] = 1;
		}
	},
	setCallback: function (elem, callbacks) {
		for (const callback in callbacks) {
			switch (callback) {
				case 'play':
				case 'playing':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('play', callbacks[callback]);
					}
					break;
				case 'pause':
				case 'paused':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('pause', callbacks[callback]);
					}
					break;
				case 'stop':
				case 'ended':
					if (typeof callbacks[callback] === 'function') {
						$(elem).bind('ended', callbacks[callback]);
					}
					break;
			}
		}
	},
	getPlayer: function (elem) {
		if (!elem) {
			return false;
		}

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('html-video')) {
			if ($(playerContainer).find('video.html-video').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('video.html-video').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('Html5 video logic needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		if (Html5Video.storage[elemId]) {
			return Html5Video.storage[elemId];
		}
		return false;
	},
	storage: [],
}

// YouTube
window.YouTubeVideo = {
	init: function (elem, settings = {}) {
		// check youtube api status
		if (typeof youtubeApiLoaded === 'undefined' || youtubeApiLoaded === false) {
			YouTubeVideo.setToWaitingList(elem, settings);
			return false;
		}

		// mark as initalized
		$(elem).addClass('init');

		// get required dom elements for player
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('youtube-iframe')) {
			if ($(playerContainer).find('.youtube-iframe').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('.youtube-iframe').get(0);
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('YouTube JavaScript API needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// default settings
		let autoplay = 0;
		let controls = 0;
		let playsinline = 1;
		let loop = 0;
		let muted = 0;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = 1;
			muted = 1;

			$(elem).addClass('playing played');
		}
		if ($(playerContainer).attr('controls')) {
			controls = 1;
		}
		/*
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') !== 'false') {
			playsinline = 1;
		}
		*/
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = 1;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = 1;
		}

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.youtube-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.youtube-video-container');
		}

		// get controls
		let controlElements;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.youtube-video-controls').length > 0) {
			controlElements = $(parentContainer).find('.video-controls.youtube-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				//$(controlElements).remove();
				$(playerContainer).addClass('hide-custom-controls');
			}
		}

		// get play button
		let playButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-play.youtube-video-play').length > 0) {
			playButton = $(controlElements).find('.video-play.youtube-video-play');
			if (autoplay === 0) {
				$(playButton).addClass('paused');
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				YouTubeVideo.togglePlayStatus(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-audio.youtube-video-audio').length > 0) {
			audioButton = $(controlElements).find('.video-audio.youtube-video-audio');
			if (muted === 1) {
				$(audioButton).addClass('muted');
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				YouTubeVideo.toggleSound(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// init player
		let player = new YT.Player(playerContainer, {
			playerVars: {
				'autoplay': autoplay,
				'modestbranding': 1,
				'controls': controls,
				'rel': 0,
				'showinfo': 0,
				'playsinline': playsinline,
				'loop': loop,
				'mute': muted,
			},
			videoId: playerContainer.dataset.id,
			events: {
				'onReady': function(e) {
					// You can perform any actions you want when the player is ready here
				},
				'onStateChange': function (e) {
					// check for callbacks
					// @todo: fix swiper bug: when in slider and loop is enabled, error "Failed to execute 'postMessage' on 'DOMWindow'" / maybe destroy yt video and init it again when loop will pass or disable automaticaly the loop
					if (typeof settings.callback !== 'undefined') {
						// playing (1)
						if (e.data === YT.PlayerState.PLAYING) {
							if (typeof settings.callback.play !== 'undefined' && typeof settings.callback.play === 'function') {
								settings.callback.play();
							}

							if ($(playButton).length > 0) {
								$(playButton).removeClass('paused visible');
							}
						}
						// paused (2)
						if (e.data === YT.PlayerState.PAUSED) {
							if (typeof settings.callback.paused !== 'undefined' && typeof settings.callback.paused === 'function') {
								settings.callback.paused();
							}

							if ($(playButton).length > 0) {
								$(playButton).addClass('paused visible');
							}
						}
						// cued/popsitioned (5)
						if (e.data === YT.PlayerState.CUED) {
							if (typeof settings.callback.cued !== 'undefined' && typeof settings.callback.cued === 'function') {
								settings.callback.cued();
							}
						}
						// ended (0)
						if (e.data === YT.PlayerState.ENDED) {
							if (typeof settings.callback.ended !== 'undefined' && typeof settings.callback.ended === 'function') {
								settings.callback.ended();
							}

							if ($(playButton).length > 0) {
								$(playButton).addClass('paused visible');
							}

							if (loop === 1) {
								e.target.playVideo();
							}
						}
					}
				},
			},
		});

		// safe player to storage
		YouTubeVideo.storage.push(player);

		// set iframe as elem
		elem = $(player.g);

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.pauseVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === -1 || player.getPlayerState() === 0 || player.getPlayerState() === 2 || player.getPlayerState() === 5) {
				YouTubeVideo.play(elem);
			} else {
				YouTubeVideo.pause(elem);
			}
		}
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = YouTubeVideo.init(elem, settings);
			return false;
		}

		$(elem).addClass('playing played');

		// return false without elem
		if (elem === false) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (player && typeof player.playVideo === 'function') {
			player.playVideo();
		}
	},
	pause: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.pauseVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === 1) {
				player.pauseVideo();
			}
		}
	},
	stop: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.stopVideo === 'function' && typeof player.getPlayerState === 'function') {
			if (player.getPlayerState() === 1 || player.getPlayerState() === 2) {
				player.stopVideo();
			}
		}
	},
	destroy: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.destroy === 'function') {
			if (typeof player.o !== 'undefined' && $(player.o).length > 0) {
				$(player.o).removeClass('init');
			}
			player.destroy();
		}
	},
	toggleSound: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.isMuted === 'function') {
			if (player.isMuted()) {
				YouTubeVideo.unmute(elem);
			} else {
				YouTubeVideo.mute(elem);
			}
		}
	},
	mute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.mute === 'function') {
			player.mute();

			// get audio control
			let audioControl;
			if ($(elem).find('.video-audio.youtube-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.youtube-video-audio');
			} else if ($(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio');
			}

			// if audio control exist, add muted class
			if ($(audioControl).length > 0) {
				$(audioControl).addClass('muted');
			}
		}
	},
	unmute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		// get video player
		let player = YouTubeVideo.getPlayer(elem);
		if (typeof player.unMute === 'function') {
			player.unMute();
		}

		// get audio control
		let audioControl;
		if ($(elem).find('.video-audio.youtube-video-audio').length > 0) {
			audioControl = $(elem).find('.video-audio.youtube-video-audio');
		} else if ($(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio').length > 0) {
			audioControl = $(elem).closest('.video-container.youtube-video-container').find('.video-audio.youtube-video-audio');
		}

		// if audio control exist, remove muted class
		if ($(audioControl).length > 0) {
			$(audioControl).removeClass('muted');
		}
	},
	setToWaitingList: function (elem, settings) {
		let id = $(elem).attr('id');
		if (id) {
			YouTubeVideo.waitingList.push({id, settings});
		}
	},
	processAllVideos: function () {
		for (let i = 0; i < YouTubeVideo.waitingList.length; i++) {
			let id = YouTubeVideo.waitingList[i]['id'];
			let elem = $('#' + id);
			let settings = {};
			if (YouTubeVideo.waitingList[i]['settings']) {
				settings = YouTubeVideo.waitingList[i]['settings'];
			}
			if (elem.length > 0) {
				YouTubeVideo.play(elem, settings);
			}
			YouTubeVideo.waitingList.splice(i, 1);
		}
	},
	getPlayer: function (elem) {
		if ($(elem).attr('id').length > 0) {
			return YT.get($(elem).attr('id'));
		}
		return false;
	},
	waitingList: [],
	callbacks: [],
	storage: [],
}

window.onYouTubeIframeAPIReady = function() {
	window.youtubeApiLoaded = true;
	if (typeof window.YouTubeVideo.processAllVideos === 'function') {
		window.YouTubeVideo.processAllVideos();
	}
}

// Vimeo
window.VimeoVideo = {
	init: function (elem, settings) {
		// check vimeo api status
		if (typeof vimeoApiLoaded === 'undefined' || vimeoApiLoaded === false) {
			VimeoVideo.setToWaitingList(elem, settings);
			return false;
		}

		// mark as initalized
		$(elem).addClass('init');

		// get player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		// player container
		if (!player.element) {
			return false;
		}
		let playerContainer = player.element;

		// get parent container
		let parentContainer;
		if ($(elem).closest('.video-container.vimeo-video-container').length > 0) {
			parentContainer = $(elem).closest('.video-container.vimeo-video-container');
		};

		// default settings
		let autoplay = 0;
		let controls = 0;
		let playsinline = 0;
		let loop = 0;
		let muted = 0;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = 1;
			muted = 1;
		}
		if ($(playerContainer).attr('controls')) {
			controls = 1;
		}
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') !== 'false') {
			playsinline = 1;
		}
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = 1;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = 1;
		}

		// get controls
		let controlElements;
		if ($(parentContainer).length > 0 && $(parentContainer).find('.video-controls.vimeo-video-controls').length > 0) {
			controlElements = $(parentContainer).find('.video-controls.vimeo-video-controls');
			if ($(playerContainer).attr('controls') && $(playerContainer).attr('controls') !== 'false') {
				//$(controlElements).remove();
				$(playerContainer).addClass('hide-custom-controls');
			}
		}

		// get play button
		let playButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-play.vimeo-video-play').length > 0) {
			playButton = $(controlElements).find('.video-play.vimeo-video-play');
			if (autoplay === 0) {
				VimeoVideo.pause(elem);
			} else {
				$(playButton).removeClass('paused');
			}
		}

		// set event listener on button
		if ($(playButton).length > 0) {
			$(playButton).on('click', function () {
				VimeoVideo.togglePlayStatus(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// get audio button
		let audioButton;
		if ($(controlElements).length > 0 && $(controlElements).find('.video-audio.vimeo-video-audio').length > 0) {
			audioButton = $(controlElements).find('.video-audio.vimeo-video-audio');
			if (muted === 1) {
				VimeoVideo.mute(elem);
			}
		}

		// set event listener on button
		if ($(audioButton).length > 0) {
			$(audioButton).on('click', function () {
				VimeoVideo.toggleSound(elem);
			}).on('keydown', function (e) {
				// Enter
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		// callbacks
		// ended
		if (typeof settings.callback.ended !== 'undefined' && typeof settings.callback.ended === 'function') {
			player.on('ended', function(data) {
				settings.callback.ended();
			});
		}

		return elem;
	},
	togglePlayStatus: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		player.getPaused().then(function (paused) {
			if (paused) {
				VimeoVideo.play(elem);
			} else {
				VimeoVideo.pause(elem);
			}
		});
	},
	play: function (elem, settings = {}) {
		// init if not happend
		if (!$(elem).hasClass('init')) {
			elem = VimeoVideo.init(elem, settings);
		}

		$(elem).addClass('playing played');

		// return false without elem
		if (elem === false) {
			return false;
		}

		// get video player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		// play video
		player.getPaused().then(function(paused) {
			let playButton;
			if ($(elem).find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).find('.video-play.vimeo-video-play');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play');
			}

			if (paused) {
				player.play();
				if (playButton.length) {
					playButton.removeClass('paused');
				}
			}
		});
	},
	pause: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');

		// get video player
		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return;
		}

		if (typeof player.getPaused === 'function') {
			let playButton;
			if ($(elem).find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).find('.video-play.vimeo-video-play');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play').length > 0) {
				playButton = $(elem).closest('.video-container.vimeo-video-container').find('.video-play.vimeo-video-play');
			}

			// pause video
			player.getPaused().then(function(paused) {
				if (!paused) {
					player.pause();

					if (playButton.length) {
						playButton.addClass('paused');
					}
				}
			});
		}
	},
	stop: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		$(elem).removeClass('playing');
	},
	toggleSound: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.getMuted === 'function') {
			player.getMuted().then(function (isMuted) {
				if (isMuted) {
					VimeoVideo.unmute(elem);
				} else {
					VimeoVideo.mute(elem);
				}
			});
		}
	},
	mute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.setMuted === 'function') {
			let audioControl;
			if ($(elem).find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.vimeo-video-audio');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio');
			}

			player.setMuted(true).then(function () {
				if (audioControl.length) {
					audioControl.addClass('muted');
				}
			});
		}
	},
	unmute: function (elem) {
		if (!$(elem).hasClass('init')) {
			return false;
		}

		let player = VimeoVideo.getPlayer(elem);
		if (!player) {
			return false;
		}

		if (typeof player.setMuted === 'function') {
			let audioControl;
			if ($(elem).find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).find('.video-audio.vimeo-video-audio');
			} else if ($(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio').length > 0) {
				audioControl = $(elem).closest('.video-container.vimeo-video-container').find('.video-audio.vimeo-video-audio');
			}

			player.setMuted(false).then(function () {
				if (audioControl.length) {
					audioControl.removeClass('muted');
				}
			});
		}
	},
	setToWaitingList: function (elem, settings) {
		let id = $(elem).attr('id');
		if (id) {
			VimeoVideo.waitingList.push({id, settings});
		}
	},
	processAllVideos: function () {
		for (let i = 0; i < VimeoVideo.waitingList.length; i++) {
			let id = VimeoVideo.waitingList[i]['id'];
			let elem = $('#' + id);
			let settings = {};
			if (VimeoVideo.waitingList[i]['settings']) {
				settings = VimeoVideo.waitingList[i]['settings'];
			}
			if (elem.length > 0) {
				VimeoVideo.init(elem, settings);
			}
			VimeoVideo.waitingList.splice(i, 1);
		}
	},
	getPlayer: function (elem, settings) {
		if (typeof Vimeo === 'undefined') {
			return false;
		}

		// get player dom elements
		let playerContainer = $(elem).get(0);
		if (!$(playerContainer).hasClass('vimeo-iframe')) {
			if ($(playerContainer).find('.vimeo-iframe').length <= 0) {
				return false;
			}
			playerContainer = $(elem).find('.vimeo-iframe').get(0);
		}

		// get player id
		let dataVimeoId;
		let dataVimeoUrl;
		if ($(playerContainer).attr('data-vimeo-id') && $(playerContainer).attr('data-vimeo-id') !== '') {
			dataVimeoId = $(playerContainer).attr('data-vimeo-id');
		} else if ($(playerContainer).attr('src') && $(playerContainer).attr('src') !== '') {
			dataVimeoUrl = $(playerContainer).attr('src').split('/');
			if (typeof dataVimeoUrl === 'object') {
				dataVimeoId = dataVimeoUrl.slice(-1)[0];
			}
		} else if ($(playerContainer).attr('data-src') && $(playerContainer).attr('data-src') !== '') {
			dataVimeoUrl = $(playerContainer).attr('data-src').split('/');
			if (typeof dataVimeoUrl === 'object') {
				dataVimeoId = dataVimeoUrl.slice(-1)[0];
			}
		}

		if (!dataVimeoId) {
			console.warn('No vimeo video id', playerContainer);
			return false;
		}

		// check if unique id is set
		if (!$(playerContainer).attr('id')) {
			console.warn('YouTube JavaScript API needs a unique id on the video DOM element');
			return false;
		}

		let elemId = $(playerContainer).attr('id');

		// default settings
		let autoplay = false;
		let controls = false;
		let playsinline = true;
		let loop = false;
		let muted = true;

		// override settings by attributes
		if ($(playerContainer).attr('autoplay') && $(playerContainer).attr('autoplay') !== 'false') {
			autoplay = true;
			muted = true;
		}
		if ($(playerContainer).attr('controls')) {
			controls = true;
		}
		if ($(playerContainer).attr('playsinline') && $(playerContainer).attr('playsinline') === 'false') {
			playsinline = false;
		}
		if ($(playerContainer).attr('loop') && $(playerContainer).attr('loop') !== 'false') {
			loop = true;
		}
		if ($(playerContainer).attr('muted') && $(playerContainer).attr('muted') !== 'false') {
			muted = true;
		}

		// options
		let options = {
			autoplay: autoplay,
			controls: controls,
			loop: loop,
			muted: muted,
		};

		let player = new Vimeo.Player(playerContainer, options);

		return player;
	},
	waitingList: [],
	callbacks: [],
	storage: [],
}

// Fullscreen menu
//

// Open
function openFullscreenMenu(el, toggle) {
	const $el = $(el);
	if ($el.data('closeTimer')) {
		clearTimeout($el.data('closeTimer'));
		$el.data('closeTimer', null);
	}
	$el.show(0, function () {
		$el.addClass('is-open');
	});
	$(toggle).addClass('is-open').attr('aria-expanded', 'true');
}

// Close
function closeAllOpenFullscreenMenus() {
	const fullscreenMenu = $('.fullscreenmenu.is-open');
	if (fullscreenMenu && $(fullscreenMenu).length > 0) {
		$(fullscreenMenu).each(function() {
			const el = $(this);
			const elId = $(el).attr('id');
			if (!elId) return false;
			const toggle = $('.fullscreenmenu-toggle[data-toggle="#' + elId + '"]');
			if (toggle && $(toggle).length > 0) {
				closeFullscreenMenu(el, toggle);
			}
		});
	}
}

function closeFullscreenMenu(el, toggle) {
	const $el = $(el);
	$el.removeClass('is-open');

	if ($el.data('closeTimer')) {
		clearTimeout($el.data('closeTimer'));
	}

	// Il timeout deve coincidere con la durata della transizione CSS (es. 500ms)
	const closeTimer = setTimeout(function () {
		$el.hide(0);
		$el.data('closeTimer', null);
	}, 500);

	$el.data('closeTimer', closeTimer);
	$(toggle).removeClass('is-open').attr('aria-expanded', 'false');
}


// Menu
//

// Open
function openMenu(timeout = 100) {
	if (window.closeMenuTimer) {
		window.clearTimeout(window.closeMenuTimer);
		window.closeMenuTimer = null;
	}
	if (window.openMenuTimer) {
		window.clearTimeout(window.openMenuTimer);
	}

	window.openMenuTimer = setTimeout(function () {
		$('html').addClass('scrollprevent');
		$('body').addClass('menuopen').removeClass('menuclosed');

		menuToggleCallback();
		window.openMenuTimer = null;
	}, timeout);
}

// Close
function closeMenu(anchor) {
	if (window.openMenuTimer) {
		window.clearTimeout(window.openMenuTimer);
		window.openMenuTimer = null;
	}
	if (window.closeMenuTimer) {
		window.clearTimeout(window.closeMenuTimer);
	}

	$('html').removeClass('scrollprevent');
	$('body').removeClass('menuopen').addClass('menuclosed');

	window.closeMenuTimer = setTimeout(function () {
		$('body').removeClass('menuclosed');
		window.closeMenuTimer = null;
	}, 400);

	menuToggleCallback();
}

// Toggle
function menuToggleCallback() {
	setTimeout(function() {
		if (typeof window.bLazy?.revalidate === 'function') {
			window.bLazy.revalidate();
		}
	}, 500);
}

// Navigation
//

// Navigation functions here

// Tabs
//

let preselectedTabItem;
function initTabs (elem, box) {
	// check if tab was preselected in url
	if(location.hash !== '' && location.hash.indexOf("!") < 0) {
		let tabName = location.hash.replace("#", "");
		let tabItem = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(tabItem).length > 0) {
			preselectedTabItem = $(tabItem);
		}
	} else if (location.href !== '' && typeof getURLParameter(location.href, 'tab') !== 'undefined') {
		let tabName = getURLParameter(location.href, 'tab');
		let tabItem = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(tabItem).length > 0) {
			preselectedTabItem = $(tabItem);
		}
	}

	// preselect tabs
	$(elem, box).each(function () {
		if (typeof $(this).find(preselectedTabItem) !== 'undefined' && $(this).find(preselectedTabItem).length > 0) {
			var preselectedItem = $(this).find(preselectedTabItem).first();
			if (typeof preselectedItem !== 'undefined' && $(preselectedItem).length > 0) {
				$(preselectedItem).addClass('active-tab');
				var tabName = $(preselectedItem).attr('data-tab');
				var tabNavAnchor = $('body').find('a[data-tab="' + tabName + '"]');
				if ($(tabNavAnchor).closest('li, .swiper-slide').length && !$(tabNavAnchor).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
					$(tabNavAnchor).closest('li, .swiper-slide').addClass('active');
				}
			}
		} else if ($(this).find('.tabs-wrapper .tab-item.active-tab').length <= 0 && !$(this).hasClass('menutabs')) {
			let firstItem = $(this).find('.tabs-wrapper .tab-item').first();
			if (typeof firstItem !== 'undefined' && $(firstItem).length > 0) {
				$(firstItem).addClass('active-tab');
				let tabName = $(firstItem).attr('data-tab');
				let tabNavAnchor = $('body').find('a[data-tab="' + tabName + '"]');
				if ($(tabNavAnchor).closest('li, .swiper-slide').length && !$(tabNavAnchor).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
					$(tabNavAnchor).closest('li, .swiper-slide').addClass('active');
				}
			}
		}
	});
	$('a[data-tab]', box).click(function (e) {
		e.preventDefault();
		changeTab($(this));
		changeTabCallback($(this).closest('.tabs-container'));
		scroll();
	});
	/*
	$(elem, box).on('click', 'a[data-tab]', function(e) {
		e.preventDefault();
		changeTab($(this));
		changeTabCallback($(this).closest('.tabs-container'));
		scroll();
	});
	*/
	changeTabCallback($(elem, box));
	$(elem).find('.tabs-nav .add', box).click(function() {
		addTabLabel($(this).closest('.tabs-container'));
	});
	$(elem, box).on('click', '.tabs-nav .remove', function() {
		removeTabLabel($(this).closest('li'));
	}).on('keydown', function (e) {
		// Enter
		if (e.key === 'Enter') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});
	addRemoveLabelCallback($(this).closest('.tabs-container'));
	/*
	$(elem).find('.tabs-nav .remove', box).click(function() {
		removeTabLabel($(this).closest('li'));
	});
	if (tabsInitialized === false) {
	}
	tabsInitialized = true;
	*/
}

function initTabNavigationSlider (elem) {
	if (typeof Slider === 'undefined' && elem.closest('.swiper-container').length === 0) {
		return;
	}

	const config = {
		autoplay: false,
		slidesPerView: 'auto',
		spaceBetween: 10,
		slidesPerGroup: 1,
	};

	const tabsSlider = new Slider($(elem), config);
}

function changeTab (elem) {
	if (typeof $(elem).attr('data-tab') !== 'undefined') {
		let tabName = $(elem).attr('data-tab');
		let tab = $('.tab-item[data-tab="' + tabName + '"]');
		if ($(elem).closest('li, .swiper-slide').length && !$(elem).closest('li, .swiper-slide').hasClass('active') && !$(elem).closest('nav').hasClass('mainnav')) {
			if ($(elem).closest('ul, .swiper-wrapper').length) {
				$(elem).closest('ul, .swiper-wrapper').find('li.active, .swiper-slide.active').removeClass('active');
			}
			$(elem).parent('li, .swiper-slide').addClass('active');
		}
		let parentWrapper = $(tab).closest('.tabs-wrapper');
		if ($(tab).length > 0 && !$(tab).hasClass('active-tab')) {
			if ($(parentWrapper).length > 0) {
				$('.tab-item', parentWrapper).removeClass('active-tab');
			}
			$(tab).addClass('active-tab');
		} else if ($(tab).length <= 0) {
			console.warn("Tab \'" + tabName + "\' doesn't exist!");
			return false;
		}
	} else {
		return false;
	}
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}
}

function changeTabCallback(tabsContainer, submitform) {
	if(typeof submitform === 'undefined') {
		submitform = false;
	}
	let currentTab = $(tabsContainer).find('.tabs-nav ul li').index($(tabsContainer).find('.tabs-nav ul li.active'));
	$(tabsContainer).attr('data-current-tab', currentTab + 1);
	//updateTotalCount();
	if(submitform) {
		let tabName = $(tabsContainer).find('.tabs-nav ul li.active a[data-tab]').attr('data-tab');
		if(tabName && $('[data-tab="'+tabName+'"]').find('form').length > 0) {
			$('[data-tab="'+tabName+'"]').find('form').submit();
		}
	}
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}
	changeTabOrValueCallback(tabsContainer);
}

function changeTabOrValueCallback(tabsContainer) {
	let tabId = $(tabsContainer).find('.tabs-nav ul li.active a[data-tab]').attr('data-tab');
	let tabForm = $('.traveldata-section .tabs-container .tab-item[data-tab="'+tabId+'"]');
	let tabContent = $('.accommodationsearch.tabs-container .tab-item[data-tab="'+tabId+'"]');

	if($(tabForm).find('input[name*="[arrival]"]').val() !== '' && $(tabForm).find('input[name*="[departure]"]').val() !== '') {
		$(tabContent).addClass('withavailability');
		$('.accordion.pricerangewrapper').removeClass('d-none');
	} else {
		$(tabContent).removeClass('withavailability');
		$('.accordion.pricerangewrapper').addClass('d-none');
	}
}

function removeTabLabel(elem) {
	let tabsContainer = $(elem).closest('.tabs-container');
	if($(tabsContainer).find('.tabs-nav nav ul li').length < 2) {
		return;
	}

	let tabId = $(elem).find('[data-tab]').attr('data-tab');
	$(elem).remove();
	$(tabsContainer).find('.tab-item[data-tab="'+tabId+'"]').remove();

	if($(tabsContainer).find('.tabs-nav nav ul li.active').length === 0) {
		$(tabsContainer).find('.tabs-nav nav ul li:last-child a[data-tab]').click();
	}

	addRemoveLabelCallback(tabsContainer);
	changeTabCallback(tabsContainer, true);
}

function addTabLabel(containerElem) {
	let newTabNumber = $(containerElem).find('.tabs-nav nav ul li').length + 1;

	// label
	let htmlLabel = $(containerElem).find('#accosearchlabeldraft').html();
	htmlLabel = htmlLabel.replaceAll('data-tab="accommodation"', 'data-tab="accommodation'+newTabNumber+'"');
	htmlLabel = htmlLabel.replaceAll('<span class="num"></span>', '<span class="num">'+newTabNumber+'</span>');
	$(htmlLabel).appendTo($(containerElem).find('.tabs-nav nav ul'));

	// form
	let draft = '';
	try {
		draft = JSON.parse($('.accosearch-formDraft').html());
		draft = draft.html;
	} catch (e) {}
	let htmlForm = '<div class="tab-item" data-tab="accommodation' + newTabNumber + '">' + draft + '</div>';
	htmlForm = htmlForm.replaceAll('[{x}]', '['+(newTabNumber - 1)+']');
	htmlForm = htmlForm.replaceAll('{x}', (newTabNumber - 1));
	htmlForm = htmlForm.replaceAll('{y}', newTabNumber);
	let tabBefore = $(containerElem).find('.tabs-wrapper .tab-item').last();
	$(htmlForm).appendTo($(containerElem).find('.tabs-wrapper'));
	let newTab = $(containerElem).find('.tabs-wrapper .tab-item').last();
	const regex = /\[[0-9]+\]/;
	$(tabBefore).find('input, select').each(function() {
		let name = $(this).attr('name');
		if(typeof name === 'undefined') {
			return;
		}
		let value = $(this).val();
		name = name.replace(regex, '['+(newTabNumber - 1)+']');
		$(newTab).find('[name="'+name+'"]').val(value);
	});
	load($('[data-tab="accommodation'+newTabNumber+'"]'));
	searchload($('[data-tab="accommodation'+newTabNumber+'"]'));
	$(containerElem).find('.tabs-nav nav ul a[data-tab]').click();
	addRemoveLabelCallback(containerElem);
	changeTabCallback(containerElem, true);
}

function addRemoveLabelCallback(containerElem) {
	if($(containerElem).find('.tabs-nav ul:not(#accosearchlabeldraft) li').length >= parseInt($(containerElem).attr('data-max-tabs'))) {
		$(containerElem).find('.add').hide();
	} else {
		$(containerElem).find('.add').show();
	}
	let index = 0;
	$(containerElem).find('.tabs-wrapper .tab-item').each(function() {
		$(this).find('input, select').each(function() {
			let name = $(this).attr('name');
			if(name) {
				$(this).attr('name', name.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']'));
			}
		});
		let attributes = ['data-passto', 'data-callback-arrival', 'data-callback-departure', 'data-id-arrival', 'data-id-departure', 'id', 'for'];
		attributes.forEach(attribute => {
			$(this).find('['+attribute+']').each(function() {
				let value = $(this).attr(attribute);
				if(value) {
					value = value.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']');
					value = value.replaceAll(/\[([0-9])+\]/g, '['+index+']');
					value = value.replaceAll(/\\\[([0-9])+\\\]/g, '\\['+index+'\\]');
					$(this).attr(attribute, value);
				}
			});
		});
		/*
		$(this).find('[data-passto], [data-callback-arrival], [data-callback-departure], [data-id-arrival], [data-id-departure]').each(function() {
			let passTo = $(this).attr('data-passto');
			let callbackArrival = $(this).attr('data-callback-arrival');
			let callbackDeparture = $(this).attr('data-callback-departure');
			let arrival = $(this).attr('data-id-arrival');
			let departure = $(this).attr('data-id-departure');
			if(passTo) {
				$(this).attr('data-passto', passTo.replaceAll(/stay\[([0-9])+\]/g, 'stay['+index+']'));
			}
			if(callbackArrival) {
				$(this).attr('data-callback-arrival', callbackArrival.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(callbackDeparture) {
				$(this).attr('data-callback-departure', callbackDeparture.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(arrival) {
				$(this).attr('data-id-arrival', arrival.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
			if(departure) {
				$(this).attr('data-id-departure', departure.replaceAll(/\[([0-9])+\]/g, '['+index+']'));
			}
		});
		*/
		index++;
	});

	// todo: finish, this is not working preperly. Temporary solved with CSS
	/*
	index = 0;
	$(containerElem).find('.tabs-nav ul li a[data-tab]').each(function() {
		let tabName = $(this).attr('data-tab');
		if(tabName.indexOf('accommodation') === 0 && $(containerElem).find('.tabs-wrapper .tab-item[data-tab="' + tabName + '"]').length > 0) {
			// $('.tabs-wrapper .tab-item[data-tab="' + 'accommodation' + (index+1) + '"]').attr('data-tab', 'accommodationX');
			$(this).attr('data-tab', 'accommodation' + (index+1));
			$('.tabs-wrapper .tab-item[data-tab="' + tabName + '"]').attr('data-tab', 'accommodation' + (index+1));
		}
		index++;
	});
	*/
}

/* @todo: write function if needed */
function recalculateTabText() {
}

// Checkbox (custom)
//

// Group
function initCheckbox(elem) {
	if ($(elem).prop('checked')) {
		$(elem).parent('label').addClass('checked');
	}
}

// Callback
function customCheckboxCallback(elem) {
}

// Text collapse
//

function textCollapse(elem, box) {
	$(elem, box).each(function() {
		let elem = $(this);
		let node = elem.get(0);

		if (!$(elem).hasClass('init')) {
			$(elem).addClass('init');
		} else {
			$(elem).removeClass('collapsed');
		}

		let lineHeight = parseInt($(elem).css('line-height'));
		let minLineHeight = lineHeight * 10;
		let originalHeight = node ? node.scrollHeight : $(elem).innerHeight();
		$(elem).addClass('collapsed').css('--original-height', `${originalHeight}px`);
		let collapsedHeight = $(elem).innerHeight();

		if ((originalHeight - collapsedHeight) <= minLineHeight) {
			// Disable collapse for short texts
			$(elem).removeClass('init collapsed').css('--original-height', '');
			return;
		}

		// Keep collapsed state and add toggle
		let toggle = $(elem).next('.text-collapse-toggle');
		if (!toggle || toggle.length <= 0) {
			$('<a href="javascript:;" class="small text-collapse-toggle">' + strings.readmore[lang] + '</a>').insertAfter(elem).click(function(e) {
				if (!$(elem).hasClass('collapsed')) {
					$(elem).addClass('collapsed');
					$(this).text(strings.readmore[lang]);
				} else {
					$(elem).removeClass('collapsed');
					$(this).text(strings.readless[lang]);
				}

				scrollToElement($(elem).closest('.article'));
			});
		}
	});
}


// Recalc header min height
function recalcHeaderMinHeight() {
	let headerMinHeight = $('.headertop').last().outerHeight();
	if (typeof headerMinHeight !== 'undefined') {
		document.documentElement.style.setProperty('--header-min-height', `${headerMinHeight}px`);
	}
}

// Read url params
function getURLParameter(url, name) {
	return (RegExp(name + '=' + '(.+?)(&|$)').exec(url)||[,null])[1];
}

// Formatter
// @todo: If used, speak with ARM because hes using it currently in the base client, ohtherwise delete function. exist also as es6 module
let Formatter = {
	formatPrice: function(amount) {
		let euroConverter = new Intl.NumberFormat('de-DE', {
			style: 'decimal',
			maximumFractionDigits: 0,
			minimumFractionDigits: 0,
		});
		amount = euroConverter.format(amount);

		return '€ ' + amount;
	},

	// date = 'Y-m-d' or something compatible with new Date();
	formatDate: function(date) {
		date  = new Date(date);
		return date.toLocaleDateString('de-DE', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: 'UTC',
		});

		/*date = new Date(date);
		return addLeadingZero(date.getDay()) + '.' + addLeadingZero(date.getMonth() + 1) + '.' + date.getFullYear();*/
	},

	daysBetweenDates: function(date1, date2) {
		date1 = new Date(date1);
		date2 = new Date(date2);

		date1 = date1.getTime() / 1000;
		date2 = date2.getTime() / 1000;
		let days = (date2 - date1) / 86400;

		days = parseInt(days);
		if(days < 0) {
			days = 0;
		}
		return days;
	},

	/*addLeadingZero: function(number) {
	   number = parseInt(number);
	   if(number < 10) {
		  number = '0'+number;
	   }
	   return number+'';
	},*/
};

// Css calc
const CssCalc = (function () {
	let cache = {
		rem: null,
		vw: null,
		vh: null,
	};

	function updateCache() {
		cache.rem = compute('1rem');
		cache.vw  = compute('1vw');
		cache.vh  = compute('1vh');
	}

	function compute(expression) {
		const el = document.createElement('div');
		el.style.position = 'absolute';
		el.style.visibility = 'hidden';
		el.style.width = expression;
		document.body.appendChild(el);
		const value = el.offsetWidth;
		document.body.removeChild(el);
		return value; // immer als Number in px
	}

	return {
		toPx(expression) {
			// Direkter Cache-Zugriff
			if (expression === '1rem') return cache.rem ?? compute('1rem');
			if (expression === '1vw')  return cache.vw  ?? compute('1vw');
			if (expression === '1vh')  return cache.vh  ?? compute('1vh');

			// calc(), em, %, px usw. → direkt berechnen
			return compute(expression);
		},
		refresh() {
			updateCache();
		},
	};
})();

// Class change observer
function onClassChange($el, callback) {
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			if (mutation.attributeName === 'class') {
				callback.call($el[0], $el);
			}
		});
	});

	observer.observe($el[0], { attributes: true });
	return observer;
}


// Check passive support
//
function passiveSupport() {
	let supportsPassive = false;
	try {
		let opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassive = true;
			}
		});
		window.addEventListener("testPassive", null, opts);
		window.removeEventListener("testPassive", null, opts);
	} catch (e) {}

	return supportsPassive;
}

// Call init function
init();

// Expose globally used functions/objects on window to ensure module compatibility
(function assignGlobalsToWindow(){
	try {
		// Core utilities
		if (typeof detectEnviroment === 'function') window.detectEnviroment = window.detectEnviroment || detectEnviroment;
		if (typeof getScrollHeight === 'function') window.getScrollHeight = window.getScrollHeight || getScrollHeight;
		if (typeof getStickyTopHeight === 'function') window.getStickyTopHeight = window.getStickyTopHeight || getStickyTopHeight;
		if (typeof detectBreakpoint === 'function') window.detectBreakpoint = window.detectBreakpoint || detectBreakpoint;
		if (typeof bpIndex === 'function') window.bpIndex = window.bpIndex || bpIndex;
		if (typeof resize === 'function') window.resize = window.resize || resize;
		if (typeof scrollToElement === 'function') window.scrollToElement = window.scrollToElement || scrollToElement;

		// Tabs
		if (typeof initTabs === 'function') window.initTabs = window.initTabs || initTabs;
		if (typeof changeTab === 'function') window.changeTab = window.changeTab || changeTab;
		if (typeof changeTabCallback === 'function') window.changeTabCallback = window.changeTabCallback || changeTabCallback;
		if (typeof changeTabOrValueCallback === 'function') window.changeTabOrValueCallback = window.changeTabOrValueCallback || changeTabOrValueCallback;
		if (typeof removeTabLabel === 'function') window.removeTabLabel = window.removeTabLabel || removeTabLabel;
		if (typeof addTabLabel === 'function') window.addTabLabel = window.addTabLabel || addTabLabel;
		if (typeof addRemoveLabelCallback === 'function') window.addRemoveLabelCallback = window.addRemoveLabelCallback || addRemoveLabelCallback;
		if (typeof recalculateTabText === 'function') window.recalculateTabText = window.recalculateTabText || recalculateTabText;

		// Helpers
		if (typeof onClassChange === 'function') window.onClassChange = window.onClassChange || onClassChange;
		if (typeof passiveSupport === 'function') window.passiveSupport = window.passiveSupport || passiveSupport;
		if (typeof CssCalc !== 'undefined') window.CssCalc = window.CssCalc || CssCalc;

		// Menus (used by markup and event handlers)
		if (typeof openMenu === 'function') window.openMenu = window.openMenu || openMenu;
		if (typeof closeMenu === 'function') window.closeMenu = window.closeMenu || closeMenu;
		if (typeof closeFullscreenMenu === 'function') window.closeFullscreenMenu = window.closeFullscreenMenu || closeFullscreenMenu;
		if (typeof openFullscreenMenu === 'function') window.openFullscreenMenu = window.openFullscreenMenu || openFullscreenMenu;

		// Init entry
		if (typeof init === 'function') window.init = window.init || init;

		// Load entry
		if (typeof init === 'function') window.load = window.load || load;
	} catch (e) {
		// Fail silently; exposing helpers should never break runtime
	}
})();
